document.querySelector('#submenuSearch').addEventListener('click', function(){
    document.querySelector('#submenuSearch').value = "";
});

document.querySelector('#menuSearch').addEventListener('click', function(){
    document.querySelector('#menuSearch').value = "";
});